import { useEffect, useState } from 'react';

const getScreenOrientation = () => (window.innerHeight > window.innerWidth ? 'portrait' : 'landscape');

const useScreenOrientation = () => {
	const [screenOrientation, setScreenOrientation] = useState<string>();

	useEffect(() => {
		const handleScreenOrientationChange = () => setScreenOrientation(getScreenOrientation());

		handleScreenOrientationChange();

		window.addEventListener('resize', handleScreenOrientationChange);

		return () => window.removeEventListener('resize', handleScreenOrientationChange);
	}, []);

	return screenOrientation;
};

export default useScreenOrientation;
